import { httpClient } from '@/services/http/httpClient'

type GetPublicInvitationLinkResponse = {
  isValid: boolean
  total_amount: number
  total_used: number
}

export async function getPublicInvitationLink(
  registerTokenId: string,
): Promise<GetPublicInvitationLinkResponse> {
  const { data } = await httpClient.get<GetPublicInvitationLinkResponse>(
    `/users/public/register-token?registerTokenId=${registerTokenId}`,
  )

  return data
}
